import { JsonProperty } from "../../../models/utilities/json-property";
import { ShipmentStatus } from "../../../transportation/models/enums/shipment-status";
import { MetricBase } from "../shared/metric-base";

export class UnplannedDeliveryMetricsGroup extends MetricBase {

    public shipmentId : number = 0;

    public shipmentName : string = '';
    
    public shipmentStatus : ShipmentStatus = ShipmentStatus.Cancelled;

    @JsonProperty({ toType: 'datetime-specific' })
    public departureTimeLocal : Date|undefined = undefined;

}
